import React, { useReducer, useContext, useState, useMemo } from 'react'
import { GlobalContext } from 'globalContext'
import { Form, Button, Icon } from 'semantic-ui-react'
import { tap, finalize } from 'rxjs/operators'
import InputMask from 'react-input-mask'
import request from 'services/http'
import { toast } from 'react-toastify'
import { useSubscription } from 'utils'

function reducer(state, action) {
    switch (action.type) {
        case 'setForm':
            return { ...state, ...action.payload }
        default:
            return state
    }
}

export default function UploadCertificateForm() {

    const [globalState] = useContext(GlobalContext)
    const [isLoading, setLoading] = useState(false)
    const [state, dispatch] = useReducer(reducer, {
        empresa: '',
        cnpj: '',
        certificado: '',
        pwd: '',
    })

    function handleChange(event, props) {
        let name, value
        if (!props)
           [name, value] = [event.target.name, event.target.value]
        else {
            name = props.name
            value = event.target.type === 'file' ? event.target.files[0] : props.value
        }
        dispatch({ type: 'setForm', payload: { [name]: value } })
    }

    function handleSubmit(event) {
        event.currentTarget.querySelector('button').blur()
        if (!(!!state.certificado) || !(!!state.empresa) || !(!!state.cnpj) || !(!!state.pwd))
            toast.error('Por favor, preencha o formulário antes de enviar.')
        else 
            setLoading(true)
    }

    const uploadCert$ = useMemo(() => {
        let data = new FormData()
        if (state.certificado)
            data.append('certificado', state.certificado, state.certificado.name)
        data.append('pwd', state.pwd)
        data.append('empresa', state.empresa)
        data.append('cnpj', state.cnpj)

        return request({ 
            url: '/empresas/certificado', 
            method: 'POST', 
            body: data 
        }).pipe(
            tap(() => toast.sucess('Certificado configurado!')),
            finalize(() => setLoading(false))
        )
    }, [state])

    useSubscription(uploadCert$, isLoading)

    return (
        <Form size='mini' onSubmit={handleSubmit} loading={isLoading} noValidate>
            <div className='row'>
                <div className="col">
                    <Form.Select required label='Empresa' search noResultsMessage='Sem resultados' placeholder='Selecione a empresa desejada' name='empresa' value={state.empresa} onChange={handleChange} options={globalState.empresas.map(x => Object.assign({}, { text: x.codDpnet + " - " + x.nomeEmpresa, value: x._id }))} />
                </div>
                <div className="col">
                    <InputMask mask='99.999.999/9999-99' name='cnpj' value={state.cnpj} onChange={handleChange} >
                        {inputProps => <Form.Input {...inputProps} required label='CNPJ' placeholder='Informe o CNPJ da empresa' />}
                    </InputMask>
                </div>
            </div>
            <div className="row pt-3">
                <div className="col">
                    <Form.Input type='file' accept='.pfx,.p12' required label='Certificado' name='certificado' onChange={handleChange}/>
                </div>
                <div className="col">
                    <Form.Input required label='Senha' name='pwd' placeholder='Informe a senha do certificado' value={state.pwd} onChange={handleChange} />
                </div>
            </div>
            <div className="row pt-3">
                <div className="col text-center">
                    <Button animated='fade' size='mini' color='green'>
                        <Button.Content visible>Enviar</Button.Content>
                        <Button.Content hidden><Icon name='upload' /></Button.Content>
                    </Button>
                </div>
            </div>
        </Form>
    )
}
